import { Mapper } from '../../../../../core/base';
import { GlsAddressWebEntity } from './gls-address-web-entity';
import { GlsAddress } from 'master-locations-library/master-locations-library/src/lib/core/domain/models/gls.model';

export class AdresseGlsWebRepositoryMapper extends Mapper<
  GlsAddressWebEntity,
  GlsAddress
> {
  mapFrom(param: GlsAddressWebEntity): GlsAddress {
    return {
      id: param.id,
      houseNumber: param.houseNumber,
      zipCode: param.zipCode,
      street: param.street,
      countryCode: param.countryCode,
      region: param.region,
      country: param.country,
      city: param.city??param.municipality,
      latitude: param.latitude,
      longitude: param.longitude,
      address: param.address,
      door: param.door,
      floor: param.floor,
      litra: param.litra,
    };
  }

  mapTo(param: GlsAddress): GlsAddressWebEntity {
    return {
      id: param.id,
      houseNumber: param.houseNumber,
      zipCode: param.zipCode,
      street: param.street,
      countryCode: param.countryCode,
      region: param.region,
      country: param.country,
      city: param.city,
      latitude: param.latitude,
      longitude: param.longitude,
      address: param.address,
      door: param.door,
      floor: param.floor,
      litra: param.litra,
      municipality: param.city!,
    };
  }
}
